import { customAlphabet } from 'nanoid';
import { parser } from './parser/parser.js';
import { buildTree } from './treeNode.js';

export const DATA_TYPE_MAP = {
    StringType: 'STRING',
    IntegerType: 'INTEGER',
    BooleanType: 'BOOLEAN',
    DateType: 'DATE',
    FloatType: 'DOUBLE',
    ListType: 'ARRAY'
};

export const tableAlias = () => {
    const prefix = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ', 1);
    const suffix = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890', 7);

    return `${prefix()}${suffix()}`;
};

export const getFormulaTree = (formula) => {
    const tree = parser.parse(formula);
    const cursor = tree.cursor();

    return buildTree(cursor, formula);
};
